<script setup lang="ts">
import { THEME_KEY } from 'vue-echarts'
import { keycloakReady } from '@/plugins/vuekeycloak'

const theme = useTheme()
const storeApp = useAppStore()
const storeU = useUtilisateurStore()
const { isAuthenticated, username } = useKeycloak()

provide(
  THEME_KEY,
  computed(() => (theme.current.value.dark ? 'dark' : undefined)),
)

onMounted(async () => {
  await keycloakReady
  if (!isAuthenticated.value) return

  // Les données persistées peuvent appartenir à la session précédente d'un autre compte.
  if (storeU.utilisateur?.nomUtilisateur && storeU.utilisateur.nomUtilisateur !== username.value) {
    storeU.déconnexion()
  }

  if (!storeU.estChargé()) storeApp.showInitialLoader = true
})
</script>

<template>
  <v-app>
    <InitialLoading v-if='storeApp.showInitialLoader'/>
    <router-view v-else/>
  </v-app>
</template>
